globalThis.dateTimeConfig = {
    isoFormat: 'utc',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeFormat: '24hr',
    systemTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: 'en',
};
const setDateUtilsConfig = (options) => {
    const defaultsOptions = Object.assign(Object.assign({}, globalThis.dateTimeConfig), options);
    const currentUserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    globalThis.dateTimeConfig['timeFormat'] = defaultsOptions['timeFormat'];
    globalThis.dateTimeConfig['isoFormat'] = defaultsOptions['isoFormat'];
    globalThis.dateTimeConfig['timezone'] = defaultsOptions['timezone'];
    globalThis.dateTimeConfig['systemTimezone'] = currentUserTimeZone;
};
const updateDateUtilsConfig = (options) => {
    Object.keys(options).forEach((optionKey) => {
        const key = optionKey;
        globalThis.dateTimeConfig[key] = options[key];
    });
};

export { setDateUtilsConfig, updateDateUtilsConfig };
